import { useState } from "react";
import { Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Panel } from "@/pages/admin/shared";

export const DangerZone = () => {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/reset-voter-data", { confirm: text });
      toast.success(`Deleted ${data.votes} votes and ${data.contacts} contacts`);
      setText("");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Panel className="mt-4 border-2 border-red-300" data-testid="danger-zone">
      <h2 className="font-display text-xl font-bold text-red-700">Danger zone · Delete all voter data</h2>
      <p className="mt-1 text-sm text-ink-muted">
        Permanently deletes every vote, voter contact (name, email, phone, consent), fraud log entry and verification code.
        Committees, categories, posters and settings are kept. This cannot be undone — export the CSV first if you need it.
      </p>
      <div className="mt-3 flex flex-wrap items-center gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type DELETE" data-testid="reset-confirm-input" className="h-10 w-40 rounded-lg border border-red-300 bg-white px-3 outline-none focus:border-red-500" />
        <button type="button" onClick={reset} disabled={text !== "DELETE" || busy} data-testid="reset-voter-data-btn" className="inline-flex h-10 items-center gap-2 rounded-full bg-red-700 px-5 text-sm font-semibold text-white disabled:opacity-40">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Trash2 className="h-4 w-4" />} Delete all voter data
        </button>
      </div>
    </Panel>
  );
};
